import * as React from 'react'
import { cn } from '../../lib/utils'

const TabsContext = React.createContext(null)

function Tabs({ value, onValueChange, children, className }) {
  return (
    <TabsContext.Provider value={{ value, onValueChange }}>
      <div className={className}>{children}</div>
    </TabsContext.Provider>
  )
}

/* Underline tab bar - a clean console look */
function TabsList({ className, ...props }) {
  return (
    <div
      className={cn('flex items-center gap-1 border-b border-border', className)}
      {...props}
    />
  )
}

function TabsTrigger({ value, className, children }) {
  const ctx = React.useContext(TabsContext)
  const active = ctx.value === value
  return (
    <button
      type="button"
      onClick={() => ctx.onValueChange(value)}
      className={cn(
        'relative -mb-px px-3 py-2 text-sm font-medium transition-colors focus-visible:outline-none',
        active ? 'text-foreground' : 'text-muted-foreground hover:text-foreground',
        className
      )}
    >
      {children}
      {active && <span className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-primary" />}
    </button>
  )
}

function TabsContent({ value, className, children }) {
  const ctx = React.useContext(TabsContext)
  if (ctx.value !== value) return null
  return <div className={cn('mt-5 focus-visible:outline-none animate-fade-up', className)}>{children}</div>
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
